export default __webpack_public_path__ + "static/InterDisplay-Thin-338db5aefc7d38fe560c673f15df9890.woff2";